export type DepositPlaidAccount = {
  account_id: string;
  account_type?: string | null;
  name?: string | null;
  mask?: string | null;
  // Current Plaid account id when the snapshot account_id is firm-data's UUID.
  // Absent on legacy Plaid snapshots, where account_id is already the Plaid id.
  plaid_account_id?: string | null;
};

const DEPOSIT_ELIGIBLE_ACCOUNT_TYPES = new Set([
  'depository/checking',
  'depository/savings',
  'checking',
  'savings',
]);

export const isDepositEligiblePlaidAccount = (account: DepositPlaidAccount): boolean => {
  const accountType = String(account.account_type || '').toLowerCase();
  return DEPOSIT_ELIGIBLE_ACCOUNT_TYPES.has(accountType);
};

export const getDepositEligiblePlaidAccounts = <TAccount extends DepositPlaidAccount>(
  accounts: readonly TAccount[],
): TAccount[] => accounts.filter(isDepositEligiblePlaidAccount);

export const getAccountFundingPlaidId = (account: DepositPlaidAccount): string => {
  const processorAccountId = account.plaid_account_id?.trim();
  return processorAccountId || account.account_id;
};
